enum ChartType {
  Line = 'line',
  Bar = 'bar',
  Table = 'table',
}

interface Dataset {
  key: string;
  label: string;
  data: (number | null)[];
  units?: string;
}

interface MeasureDetail {
  name: string;
  title?: string;
  units?: string;
  desired_trendline_direction?: string;
}

interface MeasureComparisonPayload {
  scope: 'time_series' | 'comparison';
  mode?: 'single_object' | 'multi_object';
  labels: string[];
  datasets: Dataset[];
  measure_details?: MeasureDetail[];
}

interface ComparisonGroup {
  group_id: string;
  group_name: string;
  labels: string[];
  datasets: Dataset[];
}

interface GroupedComparisonPayload {
  scope: 'comparison';
  grouped_by: 'board';
  groups: ComparisonGroup[];
  measure_details?: MeasureDetail[];
}

interface MultiObjectPayload {
  scope: 'time_series';
  mode: 'multi_object';
  labels: string[];
  objects: Array<{
    id: string;
    name: string;
    measures: Record<string, (number | null)[]>;
  }>;
  measure_details?: MeasureDetail[];
  available_measures: string[];
}

export type { Dataset, GroupedComparisonPayload, MeasureDetail, MeasureComparisonPayload, MultiObjectPayload };
export { ChartType };
